import { render, staticRenderFns } from "./ApprovalRecordDialog.vue?vue&type=template&id=da16d774"
import script from "./ApprovalRecordDialog.vue?vue&type=script&lang=js"
export * from "./ApprovalRecordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports